import Skeleton from '@srm/ui/skeleton';
import './DocumentModalSkeleton.scss';

const TAB_WIDTHS = [104, 148, 94, 116];

const Field = ({ labelWidth, valueWidth }: { labelWidth: number; valueWidth: string }) => (
    <div className="document-modal-skeleton__field">
        <Skeleton height={10} width={labelWidth} radius="sm" />
        <Skeleton height={16} width={valueWidth} radius="sm" />
    </div>
);

const DocumentModalSkeleton = () => (
    <div className="document-modal-skeleton" role="status" aria-label="Загрузка документа">
        <div className="document-modal-skeleton__visual" aria-hidden="true">
            <div className="document-modal-skeleton__tabs">
                {TAB_WIDTHS.map((width, index) => (
                    <div className="document-modal-skeleton__tab" key={width}>
                        <Skeleton height={12} width={width} radius="sm" />
                        {index === 0 && <span className="document-modal-skeleton__active-tab" />}
                    </div>
                ))}
            </div>

            <div className="document-modal-skeleton__content">
                <section className="document-modal-skeleton__section">
                    <div className="document-modal-skeleton__section-title">
                        <Skeleton height={17} width={172} radius="sm" />
                    </div>
                    <div className="document-modal-skeleton__fields">
                        <Field labelWidth={88} valueWidth="68%" />
                        <Field labelWidth={112} valueWidth="48%" />
                        <Field labelWidth={76} valueWidth="56%" />
                        <Field labelWidth={132} valueWidth="52%" />
                        <Field labelWidth={96} valueWidth="72%" />
                        <Field labelWidth={104} valueWidth="40%" />
                    </div>
                </section>

                <section className="document-modal-skeleton__section">
                    <div className="document-modal-skeleton__section-title">
                        <Skeleton height={17} width={204} radius="sm" />
                    </div>
                    <div className="document-modal-skeleton__fields document-modal-skeleton__fields--two">
                        <Field labelWidth={94} valueWidth="60%" />
                        <Field labelWidth={118} valueWidth="42%" />
                        <Field labelWidth={72} valueWidth="74%" />
                        <Field labelWidth={126} valueWidth="54%" />
                    </div>
                </section>

                <section className="document-modal-skeleton__section">
                    <div className="document-modal-skeleton__section-title">
                        <Skeleton height={17} width={156} radius="sm" />
                    </div>
                    <div className="document-modal-skeleton__table">
                        {[0, 1, 2].map((row) => (
                            <div className="document-modal-skeleton__table-row" key={row}>
                                <Skeleton height={13} width={`${54 + row * 8}%`} radius="sm" />
                                <Skeleton height={13} width={`${42 + row * 6}%`} radius="sm" />
                                <Skeleton height={13} width="58%" radius="sm" />
                                <Skeleton height={13} width={`${68 - row * 7}%`} radius="sm" />
                            </div>
                        ))}
                    </div>
                </section>
            </div>
        </div>
    </div>
);

export default DocumentModalSkeleton;
